<template>
    <button :class="['app-context-switcher-preview', active ? 'active' : null]" @click="$emit('click')">
        <div class="app-context-switcher-preview__inner">
            <img :src="require('../assets/context-switcher-mockup.svg')" />
        </div>
        <h3>{{ title }}</h3>
    </button>
</template>

<script>

    export default {
        name: 'app-context-switcher-preview',
        props: ['tools', 'preview', 'active'],
        computed: {
            // The visible item is the last in the stack
            visibleStackItem() {
                const { preview, tools } = this;
                // If preview is the current; show content from current
                if (preview.stackId === tools.currentApp.stackId) {
                    return this.tools.currentApp.appState[this.tools.currentApp.appState.length - 1];
                }
                return this.preview.stack[this.preview.stack.length - 1];
            },
            title() {
                const value = this.visibleStackItem.title;
                const n = 34;
                return (value && value.length > n) ? value.substr(0, n-1) + '...' : value;
            }
        },
    };
</script>

<style>
    .app-context-switcher-preview {
        display: flex;
        flex-direction: column;
        margin:1vw;
        opacity: 1;
        transition: opacity .4s;
    }

    .app-context-switcher-preview.active .app-context-switcher-preview__inner {
        border: 10px solid #2b75bb;
        z-index: 99;
    }

    .app-context-switcher-preview.big  .app-context-switcher-preview__inner {
        border: 0 !important;
    }

    .app-context-switcher-preview.big .app-context-switcher-preview__inner {
        transition: transform .3s;
        transform: scale(14);
        z-index: 99;
    }

    @media screen and (max-width: 800px) {
        .app-context-switcher-preview.big .app-context-switcher-preview__inner {
            transform: scale(20);
        }
    }

    .app-context-switcher-preview__inner {
        width: 25vw;
        height: 14.2vw;
        border: 1px solid rgba(0, 0, 0, 0.2);
        position: relative;
        overflow: hidden;
        border-radius:6px;
        box-shadow: 0 0 10px rgba(0,0,0,0.1);
        background:white;
        padding: 0;
        transition: transform .4s;
    }

    .app-context-switcher-preview img {
        width: 100%;
        position: absolute;
        top: -1px;
        left: -1px;
        width: 101%;
    }

    .app-context-switcher-preview h3 {
        color: rgba(255,255,255, 1);
        font-weight: 500;
        font-size: 14px;
        margin-top: 0.6vw;
    }

    .app-context-switcher-preview.is-hidden {
        opacity: 0;
        transition: opacity .4s;
    }
</style>



// WEBPACK FOOTER //
// AppSwitcherPreview.vue?3779e9d0